import styled from 'styled-components';

import DateRangeBadge from 'components/shared/DateRangeBadge';
import { END_DATE, START_DATE } from 'constants/filterKeysConstants';
import { useReferralsInsightsStore } from 'stores/referralsInsightsStore';
import { BodySmallBold } from 'styles/typography';

export default function ReferralHighlightsHeader() {
  const startDate = useReferralsInsightsStore((state) => state.filters[START_DATE]) as Date;
  const endDate = useReferralsInsightsStore((state) => state.filters[END_DATE]) as Date;

  return (
    <Header>
      <TitleGroup>
        <Title>Referral Highlights</Title>
        <DateRangeBadge startDate={startDate} endDate={endDate} />
      </TitleGroup>
    </Header>
  );
}

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.black10};
`;

const TitleGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const Title = styled(BodySmallBold)`
  color: ${({ theme }) => theme.colors.black};
`;
